/**
 * utils/seo.js
 *
 * Lightweight, dependency-free per-page <head> management: document title,
 * meta description, Open Graph/Twitter overrides, canonical link, and
 * JSON-LD structured data. Plain DOM manipulation - no reactivity needed
 * since it's only ever driven from router navigation / component mount.
 */
const DEFAULT_TITLE = 'LimmekRent - Professzionális szerszám- és gépkölcsönzés';
const DEFAULT_DESCRIPTION = 'Professzionális szerszámok és gépek bérlése rövid és hosszú távra. Széles eszközválaszték, rugalmas bérleti feltételek, szakértő ügyfélszolgálat.';
const BASE_URL = 'https://limmekrent.hu';

function setMetaTag(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

/**
 * Sets document title, meta description, OG/Twitter title+description, and
 * (when a path is given) the canonical link + og:url.
 */
export function setPageMeta({ title, description, path } = {}) {
  const finalTitle = title || DEFAULT_TITLE;
  const finalDescription = description || DEFAULT_DESCRIPTION;

  document.title = finalTitle;
  setMetaTag('name', 'description', finalDescription);
  setMetaTag('property', 'og:title', finalTitle);
  setMetaTag('property', 'og:description', finalDescription);
  setMetaTag('name', 'twitter:title', finalTitle);
  setMetaTag('name', 'twitter:description', finalDescription);

  if (path) {
    const url = `${BASE_URL}${path}`;
    setMetaTag('property', 'og:url', url);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', url);
  }
}

/** Injects/updates a JSON-LD <script> block identified by a stable id. */
export function setJsonLd(id, data) {
  let script = document.getElementById(id);
  if (!script) {
    script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = id;
    document.head.appendChild(script);
  }
  script.textContent = JSON.stringify(data);
}

export function removeJsonLd(id) {
  const script = document.getElementById(id);
  if (script) script.remove();
}
